import React, { Fragment } from "react";
import "../pages/myaccount/dashboard.css";
import noData from "../assets/images/nodatafound.svg";

const DynamicTable = (
  {
    tableHeaders,
    tableData,
    type,
    onClickPayNow,
    onClickViewReceipt,
    onClickCancelBtn,
    onClickCheckIn,
  },
  props
) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered table-membroz">
        <thead>
          <tr>
            {tableHeaders?.slice(2).map((header, index) => (
              <th style={{ textAlign: "center" }} key={index}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {/* {tableData ? ( */}
          <Fragment>
            {tableData?.map((row, index) => (
              <tr key={index}>
                {row?.slice(2).map((cell, cellIndex) => {
                  const cellClassMap = {
                    Paid: "badge p-2 badge-outline-success",
                    Unpaid: "badge p-2 badge-outline-danger",
                    deleted: "badge p-2 badge-outline-danger",
                    confirmed: "badge p-2 badge-pink",
                    requested: "badge p-2  badge-outline-blue",
                    checkout: "badge p-2 badge-light-blue",
                    checkin: "badge p-2 badge-outline-success",
                    noshow: "badge p-2 color_org",
                    cancel: "badge p-2 badge-outline-danger",
                    rentout:"badge p-2 badge_rent_color",
                    cancelled:"badge p-2 badge-outline-danger"
                  };
                  return (
                    <td key={cellIndex} style={{ textAlign: "center" }}>
                      <p className={cellClassMap[cell] || ""}>
                        {/* {cell ? cell : "-"} */}
                        {cell}
                      </p>
                    </td>
                  );
                })}
                <td>
                  {row.includes("Paid") ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <button
                        className="btn btn-primary mr-2 btn_max_width"
                        onClick={() => {
                          onClickViewReceipt(row);
                        }}
                      >
                        View receipt
                      </button>
                    </div>
                  ) : row.includes("requested") ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <button
                        className="btn btn-dark"
                        onClick={() => {
                          onClickCancelBtn(row, type);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  ) : row.includes("checkout") ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <button
                        className="btn btn-primary mr-2 btn_max_width"
                        onClick={() => {
                          onClickPayNow(row, type);
                        }}
                      >
                        Pay Now
                      </button>
                    </div>
                  ) : row.includes("cancel") ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <button
                        className="btn btn-outline-danger mr-2 btn_max_width"
                        disabled
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <button
                        className="btn btn-primary mr-2 btn_max_width"
                        onClick={() => {
                          onClickPayNow(row, type);
                        }}
                      >
                        Pay Now
                      </button>
                      <button
                        className="btn btn-dark"
                        onClick={() => {
                          onClickCancelBtn(row, type);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </Fragment>
          {/* ) : (
            <tr>
              <td colSpan={tableData[0]?.length + 1}>
                <div className="nodata_container">
                  <img src={noData} loading="lazy" alt="noData" />
                </div>
              </td>
            </tr>
          )} */}
        </tbody>
      </table>
    </div>
  );
};

export default DynamicTable;
